// Export all services
export * as authService from '@/lib/api/services/auth'
// export { contentService } from '@/lib/api/services/content'
// export { eventsService } from '@/lib/api/services/events'

// Initialize auth from stored data when app starts
import { initializeAuth } from '@/lib/api/services/auth'
initializeAuth()